import script from "./ProcesoInstitucionalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcesoInstitucionalView.vue?vue&type=script&setup=true&lang=ts"

import "./ProcesoInstitucionalView.vue?vue&type=style&index=0&id=d1a6b2e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a6b2e0"]])

export default __exports__